module.exports = __webpack_public_path__ + "img/1_jeff_d.bf2cdd7b.png";